<template>
    
</template>

<script>
export default {
    name : "UserProfile",
    data(){
        return {
            
        }
    },
    async created() {
     
    },
    methods: {
       
    }
}
</script>


// WEBPACK FOOTER //
// src/components/UserProfile.vue